import { FileText } from 'lucide-react';
import { getDocumentPdfUrl } from '@/hooks/use-documents';
import { FileViewer } from '@/components/document-panel';

interface PdfViewerProps {
  documentId: string;
}

export function PdfViewer({ documentId }: PdfViewerProps): React.ReactElement {
  const pdfUrl = getDocumentPdfUrl(documentId);

  if (!pdfUrl) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 text-muted-foreground">
        <FileText className="h-12 w-12" />
        <p className="text-sm">No document available</p>
      </div>
    );
  }

  return <FileViewer fileUrl={pdfUrl} fileName="document.pdf" withCredentials className="h-full" />;
}
